import { render, staticRenderFns } from "./ScreensaversLockers.vue?vue&type=template&id=5152b29a&"
import script from "./ScreensaversLockers.vue?vue&type=script&lang=ts&"
export * from "./ScreensaversLockers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports